import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  chakra,
  Flex,
  IconButton,
  Skeleton,
  useMultiStyleConfig,
  VStack,
} from '@chakra-ui/react';
import { ChakraDraggablePopover } from 'app/components/Core';
import { RevokeQrCodeDialog } from 'app/components/Song/Contributions/RevokeQrCodeDialog';
import { ReactComponent as CloseIcon } from 'resources/images/close.svg';
import { popupSize } from './constants';
import { QrCheckinComponentProps } from './types';

export const QrCheckinComponent: React.FC<QrCheckinComponentProps> = ({
  onFetchQrCode,
  qrCode,
  isLoading,
  hasError,
  revokeQr,
  songTitle,
  anchorEl,
  onClose,
}) => {
  const styles = useMultiStyleConfig('QrChekin', { popupSize });
  const qrImageRef = useRef<HTMLImageElement>(null);

  const [IsDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    onFetchQrCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ChakraDraggablePopover
        anchorEl={hasError ? null : anchorEl}
        height={popupSize.height}
        width={popupSize.width}
      >
        <Flex sx={styles.container} data-testid="dialog">
          {isLoading ? (
            <>
              <Box sx={styles.qrWrapper}>
                <Skeleton height={180} width={180} data-testid="qr-loader" />
              </Box>
              <VStack sx={styles.actions}>
                <Skeleton width={200} height="32px" />
                <Skeleton width={150} height="32px" />
              </VStack>
            </>
          ) : (
            <>
              <Box sx={styles.qrWrapper}>
                <chakra.img
                  data-testid="qr-image"
                  ref={qrImageRef}
                  sx={styles.qrImage}
                  src={qrCode}
                  alt="QR code"
                />
              </Box>
              <VStack sx={styles.actions}>
                <Button
                  variant="text"
                  size="md"
                  mt={3}
                  mb={1}
                  _hover={{
                    color: 'textBase',
                  }}
                  onClick={() => setIsDialogOpen(true)}
                >
                  Revoke Code
                </Button>
                <IconButton
                  h={4}
                  w={4}
                  _hover={{
                    color: 'textBase',
                  }}
                  variant="text"
                  color="iconBase"
                  icon={<CloseIcon />}
                  aria-label="close-qr-code"
                  onClick={onClose}
                />
              </VStack>
            </>
          )}
        </Flex>
      </ChakraDraggablePopover>
      <RevokeQrCodeDialog
        isOpen={IsDialogOpen}
        songTitle={songTitle}
        onClose={() => setIsDialogOpen(false)}
        handleAction={() => {
          setIsDialogOpen(false);
          revokeQr();
          onClose();
        }}
      />
    </>
  );
};
